import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { BrogliaccioDistintaModel } from '../models/brogliacci/brogliaccio-distinta.model';
import { Configurations } from "../core/configurations";
import { BrogliaccioSearchModel } from "../models/brogliacci/brogliaccio-search.model";
import { environment } from "../../environments/environment";
import { DizionarioModel } from "../models/shared/dizionario.model";
import { IncassoModel } from "../models/incassi/incasso.model";
import { LocalDb } from "../core/localdb";
import { newId, guid } from "../core/utilities";
import {AuthService} from "./auth.service";
import { DistintaModel } from '../models/brogliacci/distinta-model';

//OLD
//const DISTINTE_API: string = 'assets/mock-data/distinteincassi';


@Injectable()
export class DistinteIncassiService {
  APIDistinteIncassi = this.configuration.apiBaseUrlDistinteIncassi;
  APIStatiDistinta = this.configuration.apiBaseUrlStatiDistinte + "distinteIncassi";
  apiBaseUrlStampe=this.configuration.apiBaseUrlStampe;
  MethodLista = `listaDistinteIncassi`;
  MethodListaAssociabili = `associabili`;
  MethodListaDistintaV = `byDistintaVersamenti`;
  MethodConferma = "conferma";
  MethodPrint="print";
  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) { }

  /*
  1- elenco delle distinte (ricerca distinte incassi)
  2- elenco delle distinte associabili a distinte versamenti (per quando si crea una nuova distinta versamento)
  3- elenco delle distinte incassi appartenenti ad una distinta versamento (ci interessa sapere poi il dettaglio degli incassi)
  4- get specifica distinta
  5- salvataggio nuova distinta
  6- get lista stati distinta
  7- conferma distinta
  8- elimina distinta
  9- presa in carico distinta
  10- update
  11- stampa
  */


  getFilteredList(model: BrogliaccioSearchModel): Observable<BrogliaccioDistintaModel[]> {

    let searchParams = model || new BrogliaccioSearchModel();
    let url = this.APIDistinteIncassi + this.MethodLista;
    return this.http.post(url, searchParams)
      .map(res => { 
        return res.json() as BrogliaccioDistintaModel[]; 
      })
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

  }

  getDistinteIncassiAssociabiliList(): Observable<BrogliaccioDistintaModel[]> {
    let url = this.APIDistinteIncassi + this.MethodListaAssociabili;
    return this.http.get(url)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel)
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });


  }

  getDistinteIncassiByDistintaVersamento(gid: string): Observable<BrogliaccioDistintaModel[]> {
    let url = this.APIDistinteIncassi + this.MethodListaDistintaV;
    return this.http.get(url + '/' + gid)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel[]);

  }

  get(gid: string): Observable<DistintaModel> {
    return this.http.get(this.APIDistinteIncassi + '/' + gid)
      .map((r: Response) => r.json() as DistintaModel);

  }


  insert(lista: string[]): Observable<Response> {
    return this.http.post(this.APIDistinteIncassi, lista)
      .map(res => { 
        return res.json();
      })
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }

  getStati(): Observable<DizionarioModel[]> {
    let url = this.APIStatiDistinta;

    return this.http.get(url)
      .map((r: Response) => r.json() as DizionarioModel[])
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }

  confermaDistintaIncassi(model: DistintaModel): Observable<boolean> {

    let url = this.APIDistinteIncassi + this.MethodConferma + '/' + model.token;
    return this.http.put(url, null).map(res => { res.json(); return Observable.of(true); })
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }

  eliminaDistinta(model: DistintaModel): Observable<Response> {
    let url = this.APIDistinteIncassi;
    return this.http.delete(url + model.token).map(res => {
      return  res.json();
     })
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

  }


  stampaDistinta(token: string): Observable<Blob> {
    
    let url = this.apiBaseUrlStampe;
     return this.http.get(url+ this.MethodPrint+ "/" + token)
     .map(res => new Blob([res]));
  }

  //non usato
  presaInCaricoDistintaIncassi(model: BrogliaccioDistintaModel): Observable<BrogliaccioDistintaModel> {
    /*if (environment.production) {
      let url = this.API;
      //todo
    } else {
      let DISTINTE_DATA = this.distintedb.get();
      let editModel = DISTINTE_DATA.find(item => item.token == model.token);
      editModel.stato = STATI_DISTINTA[2];
      this.distintedb.set(DISTINTE_DATA);
      return Observable.of(editModel);
    }*/
    return null;
  }

  //non usato
  update(model: BrogliaccioDistintaModel): Observable<BrogliaccioDistintaModel> {
    /*let DISTINTE_DATA = this.distintedb.get();
    let idx = DISTINTE_DATA.findIndex(i => i.token == model.token);
    DISTINTE_DATA[idx] = Object.assign({}, model);
    this.distintedb.set(DISTINTE_DATA);
    return Observable.of(DISTINTE_DATA[idx]).delay(1000);
    */
    return null;
  }

}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/distinte-incassi.service.ts